// Mirrors the backend's _validate_password_strength (backend/server.py);
// keep both in sync if the rule ever changes.
export const PASSWORD_REQUIREMENTS = [
  { key: "length", label: "Au moins 8 caractères", test: (v) => v.length >= 8 },
  { key: "lower", label: "Une lettre minuscule", test: (v) => /[a-z]/.test(v) },
  { key: "upper", label: "Une lettre majuscule", test: (v) => /[A-Z]/.test(v) },
  { key: "digit", label: "Un chiffre ou un caractère spécial", test: (v) => /[0-9\W]/.test(v) },
];

export function isPasswordStrong(password) {
  return PASSWORD_REQUIREMENTS.every((r) => r.test(password));
}
